// Check if object is empty
export const isObjectEmpty = object => {
    return !Object.keys(object).length;
};

export const SIDE_NAV_PINNED_STORAGE_KEY = 'memoryshare-side-nav-pinned';

export const getLocalSettings = async () => {
    let settings = JSON.parse(localStorage.getItem('memoryshare-local-settings'));

    if (!settings) {
        settings = generateSettings();
    }

    return settings;
};

export const setLocalSettings = async (key, object) => {
    let settings = JSON.parse(localStorage.getItem('memoryshare-local-settings'));
    let newSettings = {
        ...settings,
        [key]: object,
    };

    localStorage.setItem('memoryshare-local-settings', JSON.stringify(newSettings));
};

export const setDictInLocalStorage = (key, dict) => {
    if (typeof dict !== 'object' || Array.isArray(dict)) {
        throw new Error('The provided data is not an object');
    }
    localStorage.setItem(key, JSON.stringify(dict));
};

export const getDictFromLocalStorage = key => {
    const storedData = localStorage.getItem(key);
    if (storedData) {
        try {
            return JSON.parse(storedData);
        } catch (e) {
            console.error('Error parsing object from local storage:', e);
            return {};
        }
    }
    return {};
};

// Set local storage item with expiration (default is 6 houros - 21600000)
export const setWithExpiry = async (key, object, ttl = 21600000) => {
    const cookie = JSON.parse(localStorage.getItem(key));
    const now = new Date();

    const item = {
        ...cookie,
        [key]: object,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
};

// retrieve local storage item with expiration
export const getWithExpiry = async key => {
    const itemStr = localStorage.getItem(key);

    // if item doesn't exist, return null
    if (!itemStr) {
        return null;
    }

    const item = JSON.parse(itemStr);
    const now = new Date();

    // if item is expired, return null
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }

    return item;
};

// Set an item in localStorage (no expiry)
export const setLocalStorage = (key, value) => {
    try {
        const serialized = JSON.stringify(value);
        localStorage.setItem(key, serialized);
    } catch (e) {
        console.error('Failed to set localStorage key:', key, e);
    }
};

// Get an item from localStorage (no expiry)
export const getLocalStorage = key => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (e) {
        console.error('Failed to parse localStorage key:', key, e);
        return null;
    }
};

// Remove an item from localStorage
export const removeLocalStorage = key => {
    try {
        localStorage.removeItem(key);
    } catch (e) {
        console.error('Failed to remove localStorage key:', key, e);
    }
};

export const getSideNavPinnedPreference = () => {
    return getLocalStorage(SIDE_NAV_PINNED_STORAGE_KEY);
};

export const setSideNavPinnedPreference = value => {
    setLocalStorage(SIDE_NAV_PINNED_STORAGE_KEY, value);
};

const generateSettings = () => {
    const settings = {
        serviceTable: {
            search: '',
            page: '',
            pageSize: '',
        },
        funeralHomesTable: {
            search: '',
            page: '',
            pageSize: '',
        },
        rendersTable: {
            search: '',
            page: '',
            pageSize: '',
        },
        appSettings: {
            menuState: 'min',
        },
    };

    localStorage.setItem('memoryshare-local-settings', JSON.stringify(settings));
    return settings;
};
